(() => {
  if (customElements.get("pill-filters-top")) return;

  class PillFiltersTop extends HTMLElement {
    constructor() {
      super();
      this.syncPillParamsToForm = this.syncPillParamsToForm.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onPopState = this.onPopState.bind(this);
      this.onFormChange = this.onFormChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPopState);
      document.addEventListener('change', this.onFormChange, true);

      // Initial sync and scroll
      if (document.readyState !== 'loading') {
        this.syncPillParamsToForm();
        setTimeout(() => this.scrollToActive(), 100);
      } else {
        document.addEventListener('DOMContentLoaded', () => {
          this.syncPillParamsToForm();
          setTimeout(() => this.scrollToActive(), 100);
        });
      }

      // Handle AJAX updates from Theme's Collection filtering
      this.observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            const items = this.querySelector('.pill-filters-top__items');
            if (items && Array.from(mutation.addedNodes).some(node => node.contains?.(items) || node === items)) {
              this.syncPillParamsToForm();
              this.scrollToActive();
              break;
            }
          }
        }
      });

      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.onPopState);
      document.removeEventListener('change', this.onFormChange, true);
      this.observer?.disconnect();
    }

    onFormChange(e) {
      if (e.target.closest('#CollectionFilterForm')) {
        this.syncPillParamsToForm();
      }
    }

    onPopState() {
      setTimeout(() => {
        this.syncPillParamsToForm();
        this.scrollToActive();
      }, 150);
    }

    onClick(e) {
      const link = e.target.closest('.js-pill-filter');
      if (!link) return;
      e.preventDefault();

      const paramName = link.dataset.paramName;
      const paramValue = link.dataset.paramValue;
      const isActive = link.dataset.isActive === 'true';

      if (isActive) return;

      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      // Remove pagination when filter changes
      params.delete('page');

      if (paramValue === 'all') {
        params.delete(paramName);
      } else {
        params.delete(paramName);
        params.append(paramName, paramValue);
      }

      const query = params.toString().replace(/%2C/gi, ',');
      const newUrl = url.origin + url.pathname + (query ? '?' + query : '');
      const ajaxEnabled =
        document.querySelector('[data-ajax-filtering]')?.getAttribute('data-ajax-filtering') === 'true';

      if (!ajaxEnabled) {
        window.location.assign(newUrl);
        return;
      }

      window.history.pushState({ path: newUrl }, '', newUrl);

      // Provide immediate visual feedback
      this.querySelectorAll('.pill-filters-top__item').forEach(item => {
        item.classList.remove('is-active');
        const btn = item.querySelector('.js-pill-filter');
        if (btn) btn.dataset.isActive = 'false';
      });

      const parentItem = link.closest('.pill-filters-top__item');
      if (parentItem) {
        parentItem.classList.add('is-active');
        link.dataset.isActive = 'true';
      }

      this.scrollToActive(parentItem);
      this.syncPillParamsToForm();
      window.dispatchEvent(new PopStateEvent('popstate'));
    }

    syncPillParamsToForm() {
      const form = document.getElementById('CollectionFilterForm');
      if (!form) return;
      form.querySelectorAll('[data-pill-filter]').forEach(el => el.remove());
      const params = new URLSearchParams(window.location.search);
      params.forEach((value, key) => {
        if (key.includes('filter.p.m.custom.collection_filter')) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          input.setAttribute('data-pill-filter', 'true');
          form.appendChild(input);
        }
      });
    }

    scrollToActive(specificItem = null) {
      const activeItem = specificItem || this.querySelector('.pill-filters-top__item.is-active');
      const container = this.querySelector('.pill-filters-top__items');
      if (activeItem && container) {
        const containerRect = container.getBoundingClientRect();
        const itemRect = activeItem.getBoundingClientRect();
        
        if (itemRect.left < containerRect.left || itemRect.right > containerRect.right) {
          container.scrollTo({
            left: activeItem.offsetLeft - (containerRect.width / 2) + (itemRect.width / 2),
            behavior: 'smooth'
          });
        }
      }
    }
  }

  customElements.define("pill-filters-top", PillFiltersTop);
})();